import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import Header from "../components/Header";
import Lookup from "../components/Lookup";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import Artplayer from "artplayer";
import "./Player.css";

export default function Player() {
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [video, setVideo] = useState("");
  const { watch } = useParams();
  const [views, setViews] = useState("");
  const [likes, setLikes] = useState("");
  const [dislikes, setDislikes] = useState("");
  const [related, setRelated] = useState([]);
  const [instances, setInstances] = useState([]);
  const [uris, setUris] = useState([]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedInstance = searchParams.get("instance");

  const recommend = `${selectedInstance}/api/v1/videos/${watch}`;

  function Player({ option, getInstance, ...rest }) {
    const artRef = useRef();

    useEffect(() => {
      const art = new Artplayer({
        ...option,
        container: artRef.current,
      });

      if (getInstance && typeof getInstance === "function") {
        getInstance(art);
      }

      return () => {
        if (art && art.destroy) {
          art.destroy(false);
        }
      };
    }, []);

    return <div ref={artRef} {...rest}></div>;
  }

  useEffect(() => {
    const fetchInstancesData = () => {
      fetch(
        "https://raw.githubusercontent.com/wiki/TeamPiped/Piped-Frontend/Instances.md"
      )
        .then((resp) => resp.text())
        .then((body) => {
          const instancesArray = [];
          const lines = body.split("\n");
          let headerFound = false;
          lines.forEach((line) => {
            if (!headerFound && line.includes("Instance Name")) {
              headerFound = true;
            } else if (headerFound) {
              const split = line.split("|");
              if (split.length === 5 && split[1].trim() !== "---") {
                instancesArray.push({
                  name: split[1].trim(),
                  apiurl: split[2].trim(),
                  locations: split[3].trim(),
                  cdn: split[4].trim(),
                });
              }
            }
          });
          setInstances(instancesArray);
          setUris(instancesArray.map((instance) => instance.name));
        })
        .catch((error) => console.error("Error fetching data:", error));
    };

    fetchInstancesData();
    setUris(instances.map((instance) => instance.name));
  }, []);

  useEffect(() => {
    fetch(recommend)
      .then((res) => res.json())
      .then((json) => {
        setRelated(json["recommendedVideos"]);
        setData3(json);
        setData2(json["formatStreams"]["1"]);
      });

    fetch(`${uris[0]}/streams/${watch}`)
      .then((res) => res.json())
      .then((json) => {
        setVideo(json["videoStreams"][json["videoStreams"].length - 1]["url"]);
        setData(json);
        // Set the document title to the video title
        document.title = json["title"];

        if (json["views"] >= 1000000) {
          setViews((json["views"] / 1000000).toFixed(1) + "M");
        } else if (json["views"] >= 1000) {
          setViews((json["views"] / 1000).toFixed(1) + "K");
        } else {
          setViews(json["views"]);
        }

        if (json["likes"] >= 1000000) {
          setLikes((json["likes"] / 1000000).toFixed(1) + "M");
        } else if (json["likes"] >= 1000) {
          setLikes((json["likes"] / 1000).toFixed(1) + "K");
        } else {
          setLikes(json["likes"]);
        }

        if (json["dislikes"] >= 1000000) {
          setDislikes((json["dislikes"] / 1000000).toFixed(1) + "M");
        } else if (json["dislikes"] >= 1000) {
          setDislikes((json["dislikes"] / 1000).toFixed(1) + "K");
        } else {
          setDislikes(json["dislikes"]);
        }
      });
  }, [recommend, uris]);

  const uploadDate = new Date(data["uploadDate"]);
  const formattedUploadDate = uploadDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  Player.MOBILE_CLICK_PLAY = false;
  return (
    <>
      <Header />
      <Lookup selectedInstance={selectedInstance} />
      <section className="text-gray-600 body-font">
        <div className="container mx-auto flex px-4 py-24 -mt-20 flex-col">
          {/* <ReactPlayer
            light={
              <img
                src={`https://i.ytimg.com/vi_webp/${watch}/mqdefault.webp`}
                alt="Thumbnail"
                width={1000}
              />
            }
            //{video} -> piped {data2.url} -> invidious
            url={data2.url}
            controls="true"
            width="100%"
            height="auto"
            playing="true"
          /> */}

          <Player
            className="artplayer-app mx-auto"
            option={{
              url: `${data2.url}`,
              hotkey: true,
              poster: `https://i.ytimg.com/vi/${watch}/maxresdefault.jpg`,
              setting: true,
              pip: true,
              playbackRate: true,
              fullscreen: true,
              autoPlayback: true,
              volume: 1,
              autoplay: true,
            }}
          />

          <div className=" w-full mt-2">
            <h1 className="title-font sm:text-4xl text-3xl mb-4 mt-4 font-medium text-gray-900">
              {data["title"]}
            </h1>
            <div className="max-w-md">
              <div className="md:flex">
                <div className="ml-0 -mt-2 mb-2">
                  <div className=" uppercase tracking-wide text-sm text-indigo-500 font-semibold">
                    <Link
                      to={{
                        pathname: `/channel/${data3["authorId"]}`,
                        search: `?instance=${selectedInstance}`,
                      }}
                    >
                      <a href="#">{data["uploader"]}</a>
                    </Link>
                  </div>
                  <p className="block mt-1 text-lg leading-tight font-medium text-black">
                    Uploaded On {formattedUploadDate}
                  </p>
                </div>
              </div>
            </div>
            <p className="mb-8 -mt-20 leading-relaxed">
              <section className="text-gray-600 body-font">
                <div className="container px-4 py-24 mx-auto">
                  <div className="flex flex-wrap -m-4 text-center py-2 -mt-6">
                    <h2 className="title-font font-small  text-gray-900 mr-1">
                      {views}
                    </h2>
                    <p className="leading-relaxed mr-4">Views</p>
                    <h2 className="title-font font-small  text-gray-900 mr-1">
                      {likes}
                    </h2>
                    <p className="leading-relaxed  mr-4">Likes</p>

                    <h2 className="title-font font-small  text-gray-900 mr-1">
                      {dislikes}
                    </h2>
                    <p className="leading-relaxed  mr-4 mb-2">Dislikes</p>
                  </div>
                </div>
              </section>
            </p>
          </div>
        </div>
      </section>
      <section className="-mt-52 container mx-auto ">
        <h1 className="sm:text-2xl text-2xl px-4 text-left font-medium text-gray-600 mt-2">
          Related Videos:
        </h1>
        <div className="flex flex-wrap ">
          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 xl:container mx-auto">
            {related.map((trend) => (
              <div class="relative">
                <Link
                  to={{
                    pathname: `/player/${trend["videoId"]}`,
                    search: `?instance=${selectedInstance}`,
                  }}
                >
                  <img
                    className="w-full object-cover object-center rounded-lg "
                    src={`https://i.ytimg.com/vi_webp/${trend["videoId"]}/mqdefault.webp`}
                    alt={trend["title"]}
                  />
                </Link>
                <h3 class="mt-2 tracking-widest text-indigo-500 text-xs font-medium title-font">
                  <Link
                    to={{
                      pathname: `/channel/${trend["authorId"]}`,
                      search: `?instance=${selectedInstance}`,
                    }}
                  >
                    {trend["author"]}
                  </Link>
                </h3>
                <h2 class="text-lg text-gray-900 font-medium title-font mb-4">
                  <Link
                    to={{
                      pathname: `/player/${trend["videoId"]}`,
                      search: `?instance=${selectedInstance}`,
                    }}
                  >
                    {trend["title"]}
                  </Link>
                </h2>
                <p class="-mt-4 leading-relaxed text-base">
                  {(() => {
                    const dateObj = new Date(trend["lengthSeconds"] * 1000);
                    const hours = dateObj.getUTCHours();
                    const minutes = dateObj.getUTCMinutes();
                    const seconds = dateObj.getSeconds();
                    return (
                      hours.toString().padStart(2, "0") +
                      ":" +
                      minutes.toString().padStart(2, "0") +
                      ":" +
                      seconds.toString().padStart(2, "0")
                    );
                  })()}
                  <span className="ml-2">{trend["publishedText"]}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
